import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Async thunk for login
export const loginAsync = createAsyncThunk(
  "auth/login",
  async (credentials) => {
    // const response = await loginUser(credentials);
    // if (response.status) {
    //   throw new Error(response.response.data.message); // Explicitly throw the error
    // }
    // return response;
  }
);

const initialState = {
  userData: null,
  isLoggedIn: false,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserProfile: (state, payload) => {
      state.userData = payload.payload;
    },
  },
  extraReducers: (builder) => {
    // Login reducers
    builder
      .addCase(loginAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginAsync.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(loginAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Login failed";
      });
  },
});

export const { setUserProfile } = authSlice.actions;

export default authSlice.reducer;
